<template>
  <v-layout style="max-width: 95vw">
    <v-container fluid v-if="userData">
      <v-row>
        <v-col cols="12" sm="12" :md="mdOnModal" :lg="lgOnModal(3)">
          <v-row class="text-center">
            <v-col cols="12" sm="12" class="d-flex justify-center">
              <v-img
                :src="
                  userData.fotoPerfil
                    ? userData.fotoPerfil
                    : '@/assets/anonymous.png'
                "
                lazy-src="@/assets/anonymous.png"
                :aspect-ratio="4 / 3"
                max-width="250px"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="12" class="pb-0">
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title
                    class="headline font-weight-bold mb-2 text-capitalize"
                    >{{
                      `${userData.nombres} ${userData.apellidoPaterno} ${userData.apellidoMaterno}`
                    }}</v-list-item-title
                  >
                  <div class="d-flex flex-column align-center">
                    <div
                      class="
                        font-weight-light
                        my-2
                        d-flex
                        justify-start
                        text-h6
                      "
                    >
                      <v-icon left color="bolsa-guinda">mdi-email</v-icon>
                      {{ userData.correoUNI }}
                    </div>
                    <div
                      class="
                        font-weight-light
                        my-2
                        d-flex
                        justify-start
                        text-h6
                      "
                      v-if="userData.correoAlternativo"
                    >
                      <v-icon left>mdi-email</v-icon>
                      {{ userData.correoAlternativo }}
                    </div>
                  </div>
                  <v-list-item-title> </v-list-item-title>
                  <v-list-item-title> </v-list-item-title>
                  <template
                    v-if="userData.sitiosWeb && userData.sitiosWeb.otros.length"
                  >
                    <v-list-item-title
                      v-for="(sitios, index) in userData.sitiosWeb.otros"
                      :key="`otros-${index}`"
                      class="subtitle-1 font-weight-light my-2"
                    >
                      <v-icon left small>mdi-web</v-icon>
                      <a :href="sitios" target="_blank">{{ sitios }}</a>
                    </v-list-item-title>
                  </template>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" :md="mdOnModal" :lg="lgOnModal(5)">
          <v-row>
            <v-col cols="12" sm="12">
              <p class="title">Sobre Mí</p>
              <div v-if="userData.sobreMi">
                <p class="font-weight-light">{{ userData.sobreMi }}</p>
              </div>

              <div
                v-else
                class="d-flex align-center justify-center mt-4 text--secondary"
              >
                <p>No especificado</p>
              </div>
            </v-col>
            <v-col sm="12" class="mx-auto pb-0">
              <div>
                <div>
                  <p class="title">Habilidades</p>
                  <div v-if="userData.habilidades.length">
                    <p class="font-weight-light">
                      {{ userData.habilidades.join(', ') }}
                    </p>
                  </div>

                  <div
                    v-else
                    class="
                      d-flex
                      align-center
                      justify-center
                      mt-4
                      text--secondary
                    "
                  >
                    <p>No especificado</p>
                  </div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" sm="12">
              <p class="title">Educación</p>
              <div v-if="userData.educacion.length">
                <v-list-item
                  three-line
                  v-for="(info, index) in userData.educacion"
                  :key="`educacion-${index}`"
                >
                  <v-list-item-avatar class="my-auto" tile left size="80">
                    <v-icon x-large color="red">mdi-library</v-icon>
                  </v-list-item-avatar>
                  <v-layout wrap d-flex width="100%">
                    <v-flex sm12 md8 align-center class="my-auto px-0">
                      <v-list-item-content>
                        <div class="overline">{{ info.tipoEstudio }}</div>
                        <v-list-item-title
                          class="headline mb-1"
                          style="white-space: initial"
                          >{{ info.tituloEstudio }}</v-list-item-title
                        >
                        <v-list-item-subtitle>{{
                          info.institución
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-flex>
                    <v-flex sm12 md4 align-center class="my-auto px-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="my-1"
                          >Desde
                          {{
                            getFormatoFecha(info.inicio)
                          }}</v-list-item-subtitle
                        >
                        <v-list-item-subtitle class="my-1"
                          >Hasta
                          {{
                            info.hastaLaFecha
                              ? 'la Actualidad'
                              : getFormatoFecha(info.fin)
                          }}</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-flex>
                    <v-divider></v-divider>
                  </v-layout>
                </v-list-item>
              </div>
              <div
                v-else
                class="d-flex align-center justify-center mt-4 text--secondary"
              >
                <p>No especificado</p>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" :md="mdOnModal" :lg="lgOnModal(4)">
          <v-row>
            <v-col cols="12" sm="12" class="mx-auto">
              <p class="title">Publicaciones</p>
              <div v-if="userData.publicaciones.length">
                <v-list-item-group>
                  <template v-for="(item, index) in userData.publicaciones">
                    <v-list-item :key="`publiclist-${index}`">
                      <v-list-item-content>
                        <v-list-item-title
                          class="font-weight-bold"
                          v-text="item.titulo"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          class="text--primary mt-2"
                          v-text="item.resumenPublicacion"
                        ></v-list-item-subtitle>
                        <v-list-item-subtitle class="text--secondary mt-2"
                          >Palabras clave:
                          {{ getPalabrasClave(item) }}</v-list-item-subtitle
                        >
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          text
                          icon
                          color="blue"
                          target="_blank"
                          :href="item.linkReferencia"
                        >
                          <v-icon large>mdi-export</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="index + 1 != userData.publicaciones.length"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list-item-group>
              </div>
              <div
                v-else
                class="d-flex align-center justify-center mt-4 text--secondary"
              >
                <p>No especificado</p>
              </div>
            </v-col>
            <v-col cols="12" sm="12">
              <p class="title">Experiencia</p>
              <div v-if="userData.experiencia.length">
                <v-list-item
                  three-line
                  v-for="(info, index) in userData.experiencia"
                  :key="index"
                >
                  <v-list-item-avatar class="my-auto" tile left size="80">
                    <v-icon x-large color="red">mdi-account-tie</v-icon>
                  </v-list-item-avatar>
                  <v-layout wrap d-flex width="100%">
                    <v-flex sm12 md8 align-center class="py-auto">
                      <v-list-item-content>
                        <div class="overline">{{ info.puesto }}</div>
                        <v-list-item-title
                          class="headline"
                          style="white-space: initial"
                          >{{ info.empresa }}</v-list-item-title
                        >
                        <v-list-item-subtitle>{{
                          info.lugarTrabajo
                        }}</v-list-item-subtitle>
                        <v-list-item-subtitle class="text-secondary"
                          >{{
                            info.extranjero ? info.paisExtranjero + ' · ' : ''
                          }}{{ getUbicacion(info) }}</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-flex>
                    <v-flex sm12 md4 align-center class="my-auto">
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >Desde
                          {{
                            getFormatoFecha(info.inicio)
                          }}</v-list-item-subtitle
                        >
                        <v-list-item-subtitle
                          >Hasta
                          {{
                            info.hastaLaFecha
                              ? 'la Actualidad'
                              : getFormatoFecha(info.fin)
                          }}</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-flex>
                    <v-divider></v-divider>
                  </v-layout>
                </v-list-item>
              </div>
              <div
                v-else
                class="d-flex align-center justify-center mt-4 text--secondary"
              >
                <p class="text--secondary">No especificado</p>
              </div>
            </v-col>
            <v-col cols="12" sm="12" class="mx-auto">
              <p class="title mb-2">Información de Contacto</p>
              <div v-if="userData.infoContacto">
                <v-list-item class="px-0">
                  <v-list-item-content class="pt-0">
                    <v-list-item-title
                      v-if="userData.infoContacto.celular.publico"
                      class="py-2 mx-3 font-weight-light d-flex align-center"
                    >
                      <v-icon medium left color="bolsa-primary"
                        >mdi-cellphone-sound</v-icon
                      >
                      <div>{{ userData.infoContacto.celular.valor }}</div>
                    </v-list-item-title>
                    <v-list-item-title
                      v-if="userData.infoContacto.facebook.publico"
                      class="py-2"
                    >
                      <v-btn
                        outlined
                        dense
                        rounded
                        :href="userData.infoContacto.facebook.valor"
                        target="_blank"
                        ><v-icon left medium color="blue">mdi-facebook</v-icon
                        >Enlace a Facebook</v-btn
                      >
                    </v-list-item-title>
                    <v-list-item-title
                      v-if="userData.infoContacto.twitter.publico"
                      class="py-1"
                    >
                      <v-btn
                        outlined
                        dense
                        rounded
                        :href="userData.infoContacto.twitter.valor"
                        target="_blank"
                        ><v-icon left medium color="#26c6da">mdi-twitter</v-icon
                        >Enlace a Twitter</v-btn
                      >
                    </v-list-item-title>
                    <v-list-item-title
                      v-if="userData.infoContacto.linkedIn.publico"
                      class="py-1"
                    >
                      <v-btn
                        outlined
                        dense
                        rounded
                        :href="userData.infoContacto.linkedIn.valor"
                        target="_blank"
                        ><v-icon left medium color="blue">mdi-linkedin</v-icon
                        >Enlace a LinkedIn</v-btn
                      >
                    </v-list-item-title>
                    <p
                      v-if="algunDatoPublico(userData.infoContacto)"
                      class="
                        d-flex
                        align-center
                        justify-center
                        mt-4
                        text--secondary
                      "
                    >
                      No hay información disponible
                    </p>
                  </v-list-item-content>
                </v-list-item>
              </div>
              <div
                v-else
                class="d-flex align-center justify-center mt-4 text--secondary"
              >
                <p class="font-weight-light font-italic">No especificado</p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script>
export default {
  props: {
    userData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    modal: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      meses: [
        { mes: 'Enero', valor: 1 },
        { mes: 'Febrero', valor: 2 },
        { mes: 'Marzo', valor: 3 },
        { mes: 'Abril', valor: 4 },
        { mes: 'Mayo', valor: 5 },
        { mes: 'Junio', valor: 6 },
        { mes: 'Julio', valor: 7 },
        { mes: 'Agosto', valor: 8 },
        { mes: 'Septiembre', valor: 9 },
        { mes: 'Octubre', valor: 10 },
        { mes: 'Noviembre', valor: 11 },
        { mes: 'Diciembre', valor: 12 }
      ]
    }
  },

  computed: {
    mdOnModal() {
      return this.modal ? 12 : 4
    }
  },

  methods: {
    getPalabrasClave(item) {
      let [...palabrasClave] = item.palabrasClave
      let keywordsJoined = palabrasClave.join(', ')
      return keywordsJoined
    },

    getFormatoFecha(objetoFecha) {
      let mesValue = this.meses.find((value) => objetoFecha.mes == value.valor)
      return mesValue.mes + ' de ' + objetoFecha.anio
    },

    lgOnModal(colNum) {
      if (this.modal) return 12
      return colNum ? colNum : 4
    },

    algunDatoPublico(infoContacto) {
      let entries = Object.entries(infoContacto)
      return !entries.some((el) => el[1]['publico'] === true)
    },

    getUbicacion(info) {
      let departamento = info.departamento ? info.departamento + ', ' : ''
      let provincia = info.provincia ? info.provincia + ', ' : ''
      let distrito = info.distrito ? info.distrito : ''
      return departamento + provincia + distrito
    }
  }
}
</script>

<style>
</style>
